module.exports = __webpack_public_path__ + "img/leaves-back-1x.753dbe28.png";